import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { Button, FileUpload, Tray } from '@frontend/design-system';
import { useListsView } from '../lists-view/use-lists-view';
import { useAudienceTray } from '../providers/audience-tray-provider';
import { downloadExampleCsv } from './download-example-csv';
import { UploadStep } from './upload-step';
import { UploadViewFooter } from './upload-view-footer';
import { UploadViewHeader } from './upload-view-header';
import { useCsvRecipientsParse } from './use-csv-recipients-parse';

export const UploadView = () => {
  const { t } = useTranslation('bulk-messaging');
  const { campaignType, trackingIdPrefix } = useAudienceTray();
  const { advanceCreateList, cancelCreateList } = useListsView();
  const parseRecipientsFromCsv = useCsvRecipientsParse();

  const handleFileUpload = async (files: File[]) => {
    const result = await parseRecipientsFromCsv(files);
    if (result.error) return;
    advanceCreateList(result.recipients);
  };

  const handleFileValidation = async (file: File) => {
    const result = await parseRecipientsFromCsv([file]);
    return result.error;
  };

  return (
    <>
      <UploadViewHeader cancelCreateList={cancelCreateList} />
      <Tray.Body>
        <UploadStep
          title={t('Step 1:')}
          instructions={t('Download File.')}
          details={t('Download the example CSV file.')}
        >
          <Button
            variant='secondary'
            onClick={() => downloadExampleCsv(campaignType)}
            trackingId={`${trackingIdPrefix}-contacts-upload-download-btn`}
            size='large'
          >
            {t('Download Example CSV')}
          </Button>
        </UploadStep>
        <UploadStep
          title={t('Step 2:')}
          instructions={t('Copy & Paste Contacts Into Downloaded File.')}
          details={t('Uploaded lists have no count restrictions.')}
        />
        <UploadStep
          title={t('Step 3:')}
          instructions={t('Upload List Below.')}
          details={
            campaignType === CampaignType.EMAIL
              ? t('Unsubscribed email addresses will not receive an email.')
              : t('Unsubscribed phone numbers will not receive a text.')
          }
        >
          <FileUpload
            trackingId={`${trackingIdPrefix}-contacts-csv-file-upload`}
            helperText={t('Drag & drop CSV or select from your computer')}
            multiple={false}
            onFileUpload={handleFileUpload}
            acceptedFileType='csv'
            keepPreviouslySelected={false}
            validateUpload={handleFileValidation}
          />
        </UploadStep>
      </Tray.Body>
      <UploadViewFooter cancelCreateList={cancelCreateList} />
    </>
  );
};
